import tw, { styled } from 'twin.macro';

export const HeaderContainer = styled.div`
  ${tw`
    flex
    justify-between
    px-6
    py-3
    fixed
    top-0
    w-full
    transition-all
    z-20
  `}
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.84) 0%,
    rgba(0, 0, 0, 0.66) 20%,
    rgba(0, 0, 0, 0.08) 50%,
    rgba(0, 0, 0, 0.66) 80%,
    rgba(0, 0, 0, 0.84) 100%
  );
  backdrop-filter: blur(9px);
  img {
    ${tw`
      h-8
      mx-2
    `}
  }

  @media (max-width: 900px) {
    padding-left: 1rem;
    padding-right: 1rem;
    img {
      height: 1.5rem;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
`;

export const HeaderMenu = styled.h2`
  ${tw`
    text-sm
    mx-2
  `}
  color: rgba(255, 255, 255, 0.4);
  cursor: default;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const HeaderLeft = styled.div`
  ${tw`
    flex
    items-center
  `}
`;

export const HeaderRight = styled.div`
  ${tw`
    flex
    items-center
    gap-3
    pr-2
  `}

  @media (max-width: 900px) {
    gap: 0.35rem;
    padding-right: 0;
  }
`;

export const HeaderIconButton = styled.button`
  ${tw`
    text-gray-400
    w-8
    h-8
    flex
    items-center
    justify-center
    rounded-full
  `}
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: default;
  pointer-events: none;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const HeaderProfileButton = styled.button`
  ${tw`
    w-9
    h-9
    rounded
    relative
  `}
  background: #f5b300;
  background-size: cover;
  background-position: center;
  border: 1px solid rgba(255, 255, 255, 0.25);
  cursor: pointer;
`;

export const HeaderMenuPanel = styled.div`
  ${tw`
    absolute
    right-0
    top-12
    w-52
    rounded-lg
    overflow-hidden
  `}
  background: rgba(12, 12, 12, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.45);
`;

export const HeaderMenuItem = styled.button`
  ${tw`
    w-full
    text-left
    px-3
    py-2
    text-sm
    font-semibold
  `}
  background: transparent;
  border: 0;
  color: rgba(245, 248, 252, 0.92);
  cursor: pointer;
  transition: background 180ms ease, color 180ms ease;

  &:hover {
    background: rgba(229, 9, 20, 0.16);
    color: #fff;
  }
`;
